import { getNav } from './model/selectors/getNav'
import navSlice, { navActions } from './model/slice/navSlice'
import { NavMenu } from './ui/NavMenu'

export default navSlice
export { NavMenu, getNav, navActions }
